import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-eventi-patrocinati',
  templateUrl: './eventi-patrocinati.component.html',
  styleUrls: ['./eventi-patrocinati.component.css']
})
export class EventiPatrocinatiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
